function NotFound() {
  return <div className="flex items-center justify-center text-display2Xl text-primary700 h-screen">404 - This page is not available!</div>;
}

export { NotFound };
